module.exports = __webpack_public_path__ + "img/唐门.026af430.png";